import { LearnerHome } from "@/components/dashboard/LearnerHome";
import type { LearningSeatProjection } from "@/lib/api/seatWorkspace";

export function SeatTodayViewSkeleton() { return <LearnerHome onRetry={() => undefined} />; }
export function SeatTodayView({ projection, onRetry, stale = false }: { projection: LearningSeatProjection; onRetry: () => void; stale?: boolean }) {
  return <LearnerHome projection={projection} stale={stale} onRetry={onRetry} />;
}
